<script setup lang="ts">
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import AiWorkspacePage from '@/components/AiWorkspace/AiWorkspacePage.vue'

setPageTitle(PageMeta.AiWorkspace.Chat.Title)

// The meta carries the page's layout and its keyboard shortcut declaration.
definePage({
  meta: PageMeta.AiWorkspace.Chat.Meta,
})
</script>

<template>
  <AiWorkspacePage />
</template>
